/* MUTO Home page — tab panels, the board's click-to-play video facade, the
 * plan selector and the sticky add to cart.
 * Idempotent; re-binds on Shopify theme editor section loads.
 */
(function () {
  'use strict';

  /* Tabs. The markup ships every panel visible and in document order, so with
   * no JS the page is long but complete rather than silently missing three
   * quarters of its content. The script is what turns it into one-at-a-time:
   * it hides the others, marks the group as tabbed, and wires the roving
   * arrow-key behaviour a tablist is expected to have. */
  function initTabs(root) {
    var groups = root.querySelectorAll('[data-mh-tabs]');
    for (var i = 0; i < groups.length; i++) {
      (function (group) {
        if (group.dataset.mhReady === 'true') return;
        var tabs = [].slice.call(group.querySelectorAll('[data-mh-tab]'));
        if (tabs.length < 2) return;
        group.dataset.mhReady = 'true';
        group.classList.add('mh--tabbed');

        function panelFor(tab) {
          var id = tab.getAttribute('aria-controls');
          return id ? group.querySelector('#' + CSS.escape(id)) : null;
        }

        function select(tab, focus) {
          for (var j = 0; j < tabs.length; j++) {
            var on = tabs[j] === tab;
            tabs[j].setAttribute('aria-selected', on ? 'true' : 'false');
            /* Only the selected tab is a tab stop; the arrows move between
             * them, which is how a tablist is meant to behave. */
            tabs[j].tabIndex = on ? 0 : -1;
            var p = panelFor(tabs[j]);
            if (p) p.hidden = !on;
            /* A tab can own more than its panel — the Benefits band keeps the
             * product's name and lede above the pill, and they have to change
             * with it. Anything naming the panel follows the panel. */
            var id = tabs[j].getAttribute('aria-controls');
            if (id) {
              var extra = group.querySelectorAll('[data-mh-for="' + id + '"]');
              for (var m = 0; m < extra.length; m++) extra[m].hidden = !on;
            }
          }
          if (focus) tab.focus();
        }

        for (var k = 0; k < tabs.length; k++) {
          (function (tab, idx) {
            tab.addEventListener('click', function () { select(tab, false); });
            tab.addEventListener('keydown', function (e) {
              var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 :
                      e.key === 'Home' ? -idx : e.key === 'End' ? tabs.length - 1 - idx : 0;
              if (!d) return;
              e.preventDefault();
              select(tabs[(idx + d + tabs.length) % tabs.length], true);
            });
          })(tabs[k], k);
        }

        var start = group.querySelector('[data-mh-tab][aria-selected="true"]') || tabs[0];
        select(start, false);
      })(groups[i]);
    }
  }

  /* Video facade: the card ships as a cover image with a play mark, and the
   * player only exists in a <template> until it is clicked, so a row of board
   * videos costs a row of images and nothing else. Autoplay is set on the
   * player markup, so the click that reveals it also starts it. */
  function initVideo(root) {
    var boxes = root.querySelectorAll('[data-mh-video]');
    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        var btn = box.querySelector('[data-mh-video-play]');
        var tpl = box.querySelector('[data-mh-video-src]');
        if (!btn || !tpl || box.dataset.mhVideoReady === 'true') return;
        box.dataset.mhVideoReady = 'true';

        btn.addEventListener('click', function () {
          var playing = document.querySelectorAll('[data-mh-video].is-playing');
          for (var j = 0; j < playing.length; j++) {
            if (playing[j] === box) continue;
            var v = playing[j].querySelector('video');
            if (v && v.pause) v.pause();
          }
          box.classList.add('is-playing');
          box.appendChild(tpl.content.cloneNode(true));
          btn.parentNode.removeChild(btn);
          var mine = box.querySelector('video');
          if (mine && mine.play) { var p = mine.play(); if (p && p.catch) p.catch(function () {}); }
        });
      })(boxes[i]);
    }
  }

  /* Plan selector. Selection is applied by data-key across the document rather
   * than within one strip, so a second copy of the strip — in the hero, say —
   * stays in step while keeping its own radio group. A browser allows only one
   * checked radio per name, so two copies sharing a name would leave one
   * radiogroup reporting nothing selected. One choice drives every route to
   * checkout, from wherever it was made. */
  /* Money. The price on the button is the line total — the selected plan's
   * unit times the quantity in the picker — so it has to be built here rather
   * than printed once by Liquid. Shopify's own money_format comes along on the
   * card, which is what keeps this currency- and locale-proof: the separators
   * and the decimal places are the shop's, not the browser's guess at them. */
  function groupNumber(cents, thousands, decimal, places) {
    var parts = (cents / 100).toFixed(places).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return places ? parts.join(decimal) : parts[0];
  }

  /* Returns null rather than a guess when the format carries no {{amount}}
   * token: there is nowhere to put the number, and a string with the currency
   * but no figure in it is worse than falling back to the server's own. */
  function formatMoney(cents, fmt, trim) {
    var found = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!found) return null;
    var token = found[1];
    var comma = token.indexOf('comma_separator') > -1;
    var space = token.indexOf('space_separator') > -1;
    var apos = token.indexOf('apostrophe_separator') > -1;
    var places = token.indexOf('no_decimals') > -1 ? 0 : 2;
    /* money_without_trailing_zeros on the server side; same rule here. */
    if (trim && places === 2 && cents % 100 === 0) places = 0;
    return fmt.replace(/\{\{\s*\w+\s*\}\}/,
      groupNumber(cents, comma ? '.' : space ? ' ' : apos ? "'" : ',', comma ? ',' : '.', places));
  }

  /* The picker belongs to the buy block and may not be on the page at all; one
   * missing or nonsense means one. */
  function quantityValue() {
    var field = document.querySelector('[data-mc-qty]');
    if (!field) return 1;
    var n = parseInt(field.value, 10);
    return n > 0 ? n : 1;
  }

  var selectedCard = null;

  function paintPrice() {
    var card = selectedCard;
    if (!card) return;
    var slots = document.querySelectorAll('[data-mh-cta-price]');
    if (!slots.length) return;
    var cents = parseInt(card.getAttribute('data-unit'), 10);
    var money = isNaN(cents) ? null : formatMoney(
      cents * quantityValue(),
      card.getAttribute('data-money-format') || '{{amount}}',
      card.getAttribute('data-money-trim') === '1');
    /* No live variant behind this card, or a money format we cannot place a
     * number into: the server-rendered figure is the only honest price there
     * is, and multiplying a typed one is not something we can do. */
    var text = money === null
      ? (card.getAttribute('data-price-full') || card.getAttribute('data-price') || '')
      : money + (card.getAttribute('data-suffix') || '');
    for (var i = 0; i < slots.length; i++) slots[i].textContent = text;
  }

  /* Delegated, so it keeps working on markup the theme editor replaces. */
  function onQuantity(e) {
    var t = e.target;
    if (t && t.getAttribute && t.getAttribute('data-mc-qty') !== null) paintPrice();
  }
  document.addEventListener('input', onQuantity);
  document.addEventListener('change', onQuantity);

  /* Copy that belongs to one plan rather than to the strip as a whole: a
   * plan's own detail, its reassurance rows, its welcome kit tiles. Every
   * plan's is already in the page, each element tagged with the card ordinals
   * it belongs to, so switching is a class and never a fetch or a re-render —
   * which is also what keeps it working on markup the theme editor replaces.
   *
   * The buy block's own namespace, like the quantity picker above: the strip
   * is shared with the home page, and one selector is better than a second
   * copy of this loop living in muto-crea.js and drifting from it.
   *
   * An untagged element belongs to every plan and is left alone, so a page
   * that never had more than one subscription behaves exactly as before. */
  function paintPlanContent(card) {
    var index = card.getAttribute('data-index');
    if (!index) return;
    var els = document.querySelectorAll('[data-mc-plan-for]');
    for (var i = 0; i < els.length; i++) {
      var list = (els[i].getAttribute('data-mc-plan-for') || '').split(/\s+/);
      els[i].classList.toggle('is-plan-off', list.indexOf(index) === -1);
    }
  }

  function setField(sel, value, offWhenEmpty) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      els[i].value = value;
      if (offWhenEmpty) els[i].disabled = !value;
    }
  }

  function selectPlan(card) {
    if (!card || card.classList.contains('is-unavailable')) return;
    var key = card.getAttribute('data-key');
    var href = card.getAttribute('data-href') || '';

    var all = document.querySelectorAll('[data-mh-plan]');
    for (var i = 0; i < all.length; i++) {
      var on = all[i].getAttribute('data-key') === key;
      all[i].classList.toggle('is-selected', on);
      var r = all[i].querySelector('input[type="radio"]');
      if (r && !r.disabled) r.checked = on;
    }
    if (href) {
      var ctas = document.querySelectorAll('[data-mh-plan-cta]');
      /* On a product page the buy button is a submit, not a link — it carries
       * no href to rewrite, and the cart fields below are what move instead. */
      for (var j = 0; j < ctas.length; j++) {
        if (ctas[j].tagName === 'A') ctas[j].setAttribute('href', href);
      }
    }

    /* The cart. These are the two fields a subscription app reads off the line
     * item, so the selected plan has to own them: the form is server-rendered
     * with the opening selection and this keeps it in step after that. A plan
     * that resolved to no live variant leaves them alone rather than emptying
     * them, so the button never posts a blank id. */
    var variantId = card.getAttribute('data-variant');
    if (variantId) {
      setField('[data-mh-cart-id]', variantId);
      /* A disabled field is not submitted at all, which is what a one-time plan
       * needs: posting an empty selling_plan is not the same as posting none. */
      setField('[data-mh-cart-plan]', card.getAttribute('data-plan') || '', true);
    }
    /* Remembered, because the price on the button has to be repainted when the
     * quantity moves as well as when the plan does. Only buttons that asked for
     * a price carry the span, so this is a no-op everywhere else — the home
     * page's buttons are plain text and stay that way. */
    selectedCard = card;
    paintPrice();
    paintPlanContent(card);
    document.dispatchEvent(new CustomEvent('muto:home:plan', {
      detail: {
        label: card.getAttribute('data-name') || '',
        price: card.getAttribute('data-price') || '',
        href: href
      }
    }));
  }

  function initPlans(root) {
    var plans = root.querySelectorAll('[data-mh-plan]');
    if (!plans.length) return;
    for (var i = 0; i < plans.length; i++) {
      (function (card) {
        card.addEventListener('click', function () { selectPlan(card); });
        var radio = card.querySelector('input[type="radio"]');
        if (radio) radio.addEventListener('change', function () { if (radio.checked) selectPlan(card); });
      })(plans[i]);
    }
    /* Announce the server-rendered selection once, so the compact label and
     * every buy link start from the plan the strip is already showing. */
    for (var k = 0; k < plans.length; k++) {
      if (plans[k].classList.contains('is-selected')) { selectPlan(plans[k]); return; }
    }
    selectPlan(plans[0]);
  }

  /* Sticky add to cart: reveal once the first band has left the viewport. It
   * watches the hero when one is on the page and falls back to a scroll
   * threshold when it isn't, so deleting the hero doesn't disable the bar. */
  function initSticky() {
    var bar = document.querySelector('[data-mh-sticky]');
    /* Its own flag: the bar also carries data-mh (it holds a plan strip), so
     * initAll has already claimed mhReady on it by the time we get here. */
    if (!bar || bar.dataset.mhStickyReady === 'true') return;
    bar.dataset.mhStickyReady = 'true';

    var label = bar.querySelector('[data-mh-sticky-label]');
    var link = bar.querySelector('[data-mh-sticky-cta]');
    /* A template can name the thing being sold on the bar itself — a product
     * page does, because "30 Day Protocol" alone says nothing about which
     * product. Where it has, the plan contributes only its price. */
    var fixed = label && label.getAttribute('data-mh-sticky-name');
    /* If the bar's own button shows the price, the label does not repeat it. */
    var onButton = !!bar.querySelector('[data-mh-cta-price]');

    document.addEventListener('muto:home:plan', function (e) {
      if (label) {
        var name = fixed || e.detail.label;
        if (name) {
          label.textContent = e.detail.price && !onButton ? name + ' \u00b7 ' + e.detail.price : name;
        }
      }
      if (link && link.tagName === 'A' && e.detail.href) link.setAttribute('href', e.detail.href);
    });

    /* On a product page the buy block holds a real cart form, and the bar's
     * link points at the page it is already on. Submit that form instead, so
     * the bar adds the selected plan rather than reloading. With no form on the
     * page — the home page, say — the link is left to do its job. */
    if (link) {
      link.addEventListener('click', function (ev) {
        var field = document.querySelector('[data-mh-cart-id]');
        var form = field && field.form;
        if (!form || !field.value) return;
        ev.preventDefault();
        /* requestSubmit, not submit: it fires the submit event, so a cart
         * drawer or a subscription app listening for it still gets its turn. */
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }

    var hero = document.querySelector('[data-mh-hero]');
    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) { bar.classList.toggle('is-visible', !entries[0].isIntersecting); },
        { rootMargin: '-40% 0px 0px 0px' }
      ).observe(hero);
      return;
    }
    var onScroll = function () {
      bar.classList.toggle('is-visible', (window.pageYOffset || document.documentElement.scrollTop) > 600);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    initTabs(scope);
    initVideo(scope);
    /* Before initPlans, not after: initPlans announces the opening selection
     * once, and a listener attached afterwards would never hear it — which on
     * a product page leaves the bar showing its fallback label until someone
     * happens to click a plan. */
    initSticky();
    initPlans(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
